module.exports = __webpack_public_path__ + "img/features3.e58ae891.jpg";